import _ from 'underscore';
import config from 'src/config';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function AccountSetupCtrl($state, $stateParams, $q, $timeout, timezoneService, sdkOrganizationService, sdkManagementUserService, alertService, sdkUtils, managementUserService, sdkVenueService, analyticsService) { //eslint-disable-line
  const vm = this;

  const currentUser = managementUserService.getCurrentUser();
  const americaTopRegexp = new RegExp(/^America\/(New_York|Montreal|Los_Angeles|Chicago)$/);
  const nonAmericaRegexp = new RegExp(/^America.*$/);

  vm.venueForm = {};
  vm.timezones = _sortTimezones(timezoneService.list());
  vm.createOrganizationAndVenue = _createOrganizationAndVenue;
  vm.termsUrl = config.TERMS_URL;
  vm.groupTimezones = _groupTimezones;

  sdkOrganizationService.listByManagementUserId(currentUser.id)
    .then(organizations => {
      vm.organizations = organizations;

      let promise;

      //if they already have exactly 1 org, check for venues
      if (vm.organizations && vm.organizations.length === 1) {
        promise = sdkVenueService.listByOrganizationId(vm.organizations[0].id, {
          fields: '_id'
        });
      } else {
        promise = $q.resolve(null);
      }

      return promise
        .then(venues => {
          vm.venues = venues;

          if (vm.organizations && vm.organizations.length) {
            if (vm.organizations.length === 1) {
              //if they only have 1 org and no venues then let them use this page
              vm.venueForm.organizationName = vm.organizations[0].name;

              if (vm.venues && vm.venues.length >= 1) {
                //they already atleast 1 venue setup, redirect them into the app
                vm.alreadySetup = true;

                $timeout(() => {
                  $state.go('app.selectOrganization', {
                    autoSelect: true
                  });
                }, 3000);

                return;
              }
            } else {
              //if they already have multiple orgs then just redirect them into the app
              //we don't know if they have venues, and don't know which org to pick
              vm.alreadySetup = true;

              $timeout(() => {
                $state.go('app.selectOrganization', {
                  autoSelect: true
                });
              }, 3000);

              return;
            }
          }

          //form defaults
          const currentTimezone = timezoneService.determine();

          if (currentTimezone) {
            vm.venueForm.timezone = _.findWhere(vm.timezones, {
              value: currentTimezone
            });
          }
          if (!vm.venueForm.timezone) {
            vm.venueForm.timezone = _.findWhere(vm.timezones, {
              value: 'America/New_York'
            });
          }
        });
    });

  // ----------------------- private helpers ----------------------- //
  function _groupTimezones(item) {
    return item && item.key ? item.key.split('/')[0] : '';
  }

  function _sortTimezones(timezones) {
    const americaTopTimezones = _.filter(timezones, timezone => {
      return timezone.match(americaTopRegexp);
    });
    americaTopTimezones.reverse();

    const americanTimezones = _.filter(timezones, timezone => {
      return timezone.match(nonAmericaRegexp) && !timezone.match(americaTopRegexp);
    });

    const nonAmericaTimezones = _.filter(timezones, timezone => {
      return !timezone.match(nonAmericaRegexp);
    });

    return americaTopTimezones.concat(americanTimezones).concat(nonAmericaTimezones);
  }

  function _createOrganizationAndVenue(form, $event) {
    if (!form) return;
    if ($event) $event.preventDefault();

    vm.submitted = true;

    if (!form.$valid) return;

    vm.saving = true;

    const orgPromise = !vm.organizations || !vm.organizations.length ? sdkOrganizationService.createByManagementUserId(currentUser.id, {
      name: vm.venueForm.organizationName || currentUser.email
    }) : $q.resolve(null);

    orgPromise
      .then(organization => {
        if (!vm.organizations || !vm.organizations.length) {
          analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_ORGANIZATION);
        }

        sdkVenueService.createByOrganizationId(vm.organizations && vm.organizations.length ? vm.organizations[0].id : organization.id, {
            name: vm.venueForm.venueName,
            timezone: vm.venueForm.timezone.value,
            website: vm.venueForm.website
          })
          .then(() => {
            analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_VENUE);

            $state.go('app.organization.manage.reservations', {
              organizationId: vm.organizations && vm.organizations.length ? vm.organizations[0].id : organization.id,
              signedUp: true
            });
          })
          .catch(response => {
            vm.errorMsg = sdkUtils.getErrorFromResponse(response);
          });
      })
      .catch(response => {
        vm.errorMsg = sdkUtils.getErrorFromResponse(response);
      });
  }
}

AccountSetupCtrl.$inject = [
  '$state',
  '$stateParams',
  '$q',
  '$timeout',
  'timezoneService',
  'jsSdk.organization',
  'jsSdk.managementUser',
  'alertService',
  'jsSdk.utils',
  'jsSdk.managementUser',
  'jsSdk.venue',
  'analyticsService'
];

export default AccountSetupCtrl;



// WEBPACK FOOTER //
// ./src/components/accountSetup/accountSetupCtrl.js